"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["newsletterLink"],

  data: function data() {
    return {
      email: "",
      errors: [],
      oldInput: {}
    };
  },
  mounted: function mounted() {
    var requestData = this.$store.getters.pullRequestErrorsAndOldInputByAction("add-project");
    this.errors = requestData.errors;
    this.oldInput = requestData.oldInput;

    if (!_.isEmpty(this.oldInput)) {
      this.email = this.oldInput.email;
    }
  },

  computed: {
    isDashboard: function isDashboard() {
      //TODO:: Temporary disabled newsletter section
      return false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/general/Footer.vue
// module id = IEOp
// module chunks = 0 1